import styled from 'styled-components';

const checkNegative = (margin, theme) => {
  const str = margin.toString();
  if (str.startsWith('-')) {
    return '-' + theme.spacing[`m${margin.slice(1)}`];
  }
  return theme.spacing[`m${margin}`];
};

const margins = (p) => ({
  ...(p.mt && { marginTop: checkNegative(p.mt, p.theme) }),
  ...(p.mr && { marginRight: checkNegative(p.mr, p.theme) }),
  ...(p.mb && { marginBottom: checkNegative(p.mb, p.theme) }),
  ...(p.ml && { marginLeft: checkNegative(p.ml, p.theme) }),
  ...(p.margin && { margin: checkNegative(p.margin, p.theme) }),
});

const padding = (p) => ({
  ...(p.pt && { paddingTop: p.theme.spacing[`m${p.pt}`] }),
  ...(p.pr && { paddingRight: p.theme.spacing[`m${p.pr}`] }),
  ...(p.pb && { paddingBottom: p.theme.spacing[`m${p.pb}`] }),
  ...(p.pl && { paddingLeft: p.theme.spacing[`m${p.pl}`] }),
  ...(p.padding && { padding: p.theme.spacing[`m${p.padding}`] }),
});

export const Box = styled(
  ({
    flex,
    wrap,
    alignItems,
    justifyContent,
    gap,
    grow,
    flexDirection,
    relative,
    ellipsis,
    m,
    p,
    w,
    h,
    mt,
    mb,
    ml,
    mr,
    backgroundColor,
    color,
    type,
    active,
    noShrink,
    border,
    borderRadius,
    borderRight,
    center,
    column,
    maxW,
    inactive,
    ...rest
  }) => <div {...rest} />
)((p) => ({
  display: p.flex ? 'flex' : 'block',
  justifyContent: p.justifyContent || 'flex-start',
  alignItems: p.alignItems || 'flex-start',
  flexDirection: p.flexDirection || 'row',
  ...(p.relative && { position: 'relative' }),
  ...(p.w && { width: p.theme.spacing[`m${p.w}`] || p.w }),
  ...(p.h && { height: p.theme.spacing[`m${p.h}`] || p.h }),
  ...(p.m && { margin: p.theme.spacing[`m${p.m}`] || p.m }),
  ...(p.p && { padding: p.theme.spacing[`m${p.p}`] || p.p }),
  ...(p.grow && { flexGrow: 1 }),
  ...(p.gap && { gap: p.theme.spacing[`m${p.gap}`] || p.gap }),
  ...(p.wrap && { flexWrap: 'wrap' }),
  ...(p.column && { flexDirection: 'column' }),
  ...(p.hCenter && { alignItems: 'center' }),
  ...(p.vCenter && { justifyContent: 'center' }),
  ...(p.center && { justifyContent: 'center', alignItems: 'center', textAlign: 'center' }),
  ...(p.right && { alignItems: 'flex-end', textAlign: 'right' }),
  ...(p.spaceBetween && { justifyContent: 'space-between' }),
  ...(p.backgroundColor && { backgroundColor: p.theme.colors[p.backgroundColor] }),
  ...(p.color && { color: p.theme.colors[p.color] }),
  ...(p.onClick && { cursor: 'pointer' }),
  ...(p.noShrink && { flexShrink: 0 }),
  ...(p.maxW && { maxWidth: p.maxW }),
  ...(p.minW && { minWidth: p.minW }),
  ...(p.borderRadius && { borderRadius: p.borderRadius }),
  ...(p.overflow && { overflow: p.overflow }),
  ...(p.ellipsis && { textOverflow: 'ellipsis', whiteSpace: 'nowrap' }),
  ...(p.border && {
    border: '0.0625rem solid',
    borderColor: p.theme.colors.purple10,
    borderRadius: '0.25rem',
    boxSizing: 'border-box',
  }),
  ...(p.borderRight && {
    borderRight: '0.0625rem solid',
    borderColor: p.theme.colors.purple10,
  }),
  ...(p.inactive && {
    pointerEvents: 'none',
    opacity: 0.5,
  }),
  ...margins(p),
  ...padding(p),
}));
